import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const BupaCSPConfig = {
  cspConfiguration: {
    partner: 'bupa',
    partnerTitle: 'BUPA Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'bupa-sit-petportal-auth.petsure.com.au',
        appClientId: 'C8DrwMIWemQABnBue1BPIs0JnFdhya7b',
        cspMfaUrl: 'https://bupa-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-bupa-sys.petsure.com.au/account-verification'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'bupa-uat-petportal-auth.petsure.com.au',
        appClientId: 'mEyD0zV375v2JBE9Eli65Y7bw78XlcrN',
        cspMfaUrl: 'https://bupa-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-bupa-uat.petsure.com.au/account-verification'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-preprod-auth.bupapetinsurance.com.au',
        appClientId: 'uVM6GCFenvG2EuTn9Moj4r1THnhE2cL5',
        cspMfaUrl: 'https://bupa-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-preprod.bupapetinsurance.com.au/account-verification'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.bupapetinsurance.com.au',
        appClientId: 'L99O1Eu6vVkLXqsKjXdtMbQwgDdiGKe4',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://bupa-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal.bupapetinsurance.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'bupa.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'bupa.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'bupa.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'bupa.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-bupa.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-bupa.png'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/bupa-favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/bupa-favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/bupa-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/bupa-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/bupa-footer.png',
        imageTitle: 'Bupa Pet Insurance',
        imageTitleDescription: 'Bupa Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/bupa-footer.png',
        imageTitle: 'Bupa Pet Insurance',
        imageTitleDescription: 'Bupa Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Bupa - Pet Portal Login',
      description:
        'Access your Bupa Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
